import { render, staticRenderFns } from "./HosipitalAsset.vue?vue&type=template&id=b739e90c&scoped=true"
import script from "./HosipitalAsset.vue?vue&type=script&lang=js"
export * from "./HosipitalAsset.vue?vue&type=script&lang=js"
import style0 from "./HosipitalAsset.vue?vue&type=style&index=0&id=b739e90c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b739e90c",
  null
  
)

export default component.exports